import { cn } from '@/lib/cn';

interface ProgressProps {
  value: number;
  max?: number;
  className?: string;
  label?: string;
  tone?: 'accent' | 'success' | 'warning' | 'danger';
}

export function Progress({
  className,
  label = 'Fortschritt',
  max = 100,
  tone = 'accent',
  value
}: ProgressProps) {
  const percentage = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  const tones = {
    accent: 'bg-accent',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger'
  };

  return (
    <div
      aria-label={`${label}: ${Math.round(percentage)} Prozent`}
      aria-valuemax={max}
      aria-valuemin={0}
      aria-valuenow={Math.min(max, Math.max(0, value))}
      className={cn('h-2 overflow-hidden rounded-full bg-elevated', className)}
      role="progressbar"
    >
      <div
        className={cn('h-full rounded-full transition-[width]', tones[tone])}
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}
